import { useAbExperimentBucket } from 'hooks/abExperiment/useAbExperimentBucket';
import { useSetDocumentTitle } from 'hooks/useSetDocumentTitle';
import { searchFacetsVolop } from 'modules/search/constants/searchFacetsVolop';
import { SearchPage } from 'modules/search/pages/Search/SearchPage';

export function SearchVolopsPage() {
  useSetDocumentTitle(
    /* TRANSLATORS: volop search page title */
    getText('Volunteering, Donations, and more'),
  );

  const [bucketValue] = useAbExperimentBucket('NEW_SEARCH_2025_03');

  return (
    <SearchPage
      noSidebar={bucketValue === 'ENABLED'}
      searchType="VOLOP"
      searchFacets={searchFacetsVolop}
      allowAds={false}
    />
  );
}
